import { CS } from "../../../utils/modules/reselect";
import { sharedSelectors } from "../../shared/core/sharedSelectors";


export const preorderSelectors = {
  intervals: CS(sharedSelectors.preorderIntervals, preorderIntervals => preorderIntervals.get('data')),
};
